import { z } from '../zod';
import { ObjectIdStringValidationSchema } from '../shared/ObjectId';

export const GetEventPageInputValidationSchema = z.object({
  pageId: ObjectIdStringValidationSchema.meta({
    description: 'The ID of the event page to retrieve.',
    example: '507f1f77bcf86cd799439011',
  }),
});
